import React, { useState } from "react";
import { FaPlus } from "react-icons/fa";
import SelectDropdown from "../../forms/selectDropdown";

const FilterModal = ({
    filters,
    setFilters,
    operators,
    allColumns,
    onClose,
}) => {
    const [localFilters, setLocalFilters] = useState(filters);

    const handleFieldChange = (index, value) => {
        const updatedFilters = [...localFilters];
        updatedFilters[index].field = value;
        setLocalFilters(updatedFilters);
    };

    const handleOperatorChange = (index, value) => {
        const updatedFilters = [...localFilters];
        updatedFilters[index].operator = value;
        setLocalFilters(updatedFilters);
    };

    const handleValueChange = (index, value) => {
        const updatedFilters = [...localFilters];
        updatedFilters[index].value = value;
        setLocalFilters(updatedFilters);
    };

    const handleRemoveFilter = (index) => {
        if (index === 0 && localFilters.length === 1) {
            setLocalFilters([{ field: "", operator: "", value: "" }])
        } else {
            const updatedFilters = [...localFilters];
            updatedFilters.splice(index, 1);
            setLocalFilters(updatedFilters);
        }
    };

    const handleAddColumn = (index) => {
        setLocalFilters((prevFilters) => {
            const newFilters = [...prevFilters];
            newFilters.splice(index + 1, 0, { field: "", operator: "", value: "" });
            return newFilters;
        });
    };


    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center rounded">
            <div
                className="bg-white w-11/12 md:w-2/3 lg:w-1/2 rounded-md shadow-md flex flex-col h-full"
                style={{ maxHeight: "80%" }}
            >
                {/* Header */}
                <div className="text-start p-4 sticky top-0 bg-white z-10 border-b text-primary">
                    <h3 className="text-lg font-semibold">Filters</h3>
                </div>

                {/* Scrollable Filters */}
                <div className="p-6 overflow-y-auto flex-grow">
                    {localFilters.map((filter, index) => (
                        <div key={index} className="flex items-center gap-4 mb-4">
                            <div className="w-1/3">
                                <SelectDropdown
                                    options={allColumns}
                                    value={filter.field}
                                    onChange={(name, value) => handleFieldChange(index, value)}
                                    placeholder="Select field"
                                    name="field"
                                    className="input-field w-full"
                                />
                            </div>

                            <div className="w-1/3">
                                <SelectDropdown
                                    options={operators}
                                    value={filter.operator}
                                    onChange={(name, value) => handleOperatorChange(index, value)}
                                    placeholder="Select operator"
                                    name="operator"
                                    className="input-field w-full"
                                />
                            </div>

                            <div className="w-1/3">
                                <input
                                    type="text"
                                    className="p-2 input-field"
                                    value={filter.value}
                                    placeholder="Enter Value"
                                    onChange={(e) => handleValueChange(index, e.target.value)}
                                />
                            </div>

                            {/* Add Icon */}
                            <button
                                type="button"
                                onClick={() => handleAddColumn(index)}
                                className="text-green-500 ml-2"
                            >
                                <FaPlus />
                            </button>

                            {/* Remove Icon */}
                            <button
                                type="button"
                                onClick={() => handleRemoveFilter(index)}
                                className="text-red-500 font-bold ml-2"
                            >
                                ✕
                            </button>
                        </div>
                    ))}
                </div>

                {/* Footer */}
                <div className="p-4 sticky bottom-0 bg-white z-10 border-t flex justify-between gap-3">
                    <button
                        type="button"
                        onClick={() => { setFilters(localFilters); onClose() }}
                        className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
                    >
                        Add Filter
                    </button>
                    <button
                        type="button"
                        onClick={onClose}
                        className="bg-gray-500 text-white px-4 py-2 rounded-md hover:bg-gray-600"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FilterModal;
